import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
import trash2Fill from '@iconify/icons-eva/trash-2-fill';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
import expand from '@iconify/icons-eva/expand-outline';
import less from '@iconify/icons-ic/fullscreen-exit';
import roundDownload from '@iconify/icons-ic/round-download';
// material
import { styled } from '@mui/material/styles';
import {
  Box,
  Toolbar,
  Tooltip,
  IconButton,
  Typography,
  OutlinedInput,
  InputAdornment
} from '@mui/material';
import { CSVDownload, CSVLink } from 'react-csv';

// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3)
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

// ----------------------------------------------------------------------

WWCToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func
};

export default function WWCToolbar({
  numSelected,
  filterName,
  onFilterName,
  placeholder,
  csvData,
  ageGroup,
  toggleFullscreen,
  fullTable
}) {
  return (
    <RootStyle
      sx={{
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: 'primary.lighter'
        })
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <SearchStyle
          value={filterName}
          onChange={onFilterName}
          placeholder={placeholder}
          startAdornment={
            <InputAdornment position="start">
              <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
            </InputAdornment>
          }
        />
      )}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <Icon icon={trash2Fill} />
          </IconButton>
        </Tooltip>
      ) : (
        <div>
          {fullTable ? (
            <Tooltip title="View full table">
              <IconButton onClick={toggleFullscreen}>
                <a>
                  <Icon icon={expand} />
                </a>
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title="View less">
              <IconButton onClick={toggleFullscreen}>
                <a>
                  <Icon icon="ph:arrows-in-simple" />
                </a>
              </IconButton>
            </Tooltip>
          )}
          <Tooltip title="Download CSV">
            <IconButton>
              <CSVLink data={csvData} style={{ color: '#637381' }} filename={`${ageGroup}.csv`}>
                <Icon icon="ph:file-csv-bold" />
              </CSVLink>
            </IconButton>
          </Tooltip>
        </div>
      )}
    </RootStyle>
  );
}
